import { render, staticRenderFns } from "./ddo-tasks.vue?vue&type=template&id=e6277838"
import script from "./ddo-tasks.vue?vue&type=script&lang=js"
export * from "./ddo-tasks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports